import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';

export const StyledContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 6rem;
  gap: 2rem;
`;

export const StyledSaveChangesButton = styled(Button)`
  &&& {
    height: 2.875rem;
    min-width: 9.625rem;
    background-color: ${COLORS.YELLOW_PRIMARY};
    border-color: transparent;

    &&&:hover {
      background-color: ${COLORS.YELLOW_PRIMARY};
    }

    &&&:disabled {
      background-color: ${COLORS.LIGHT_GRAY};
      border-color: transparent;
      opacity: 0.5;
    }
  }
`;

export const StyledContainerTitle = styled.div`
  ${pickThemeFontStyles('20', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
`;
